import React, { useState } from 'react';
import { Div } from '@kizi/core-components';
import { IconV2 as Icon } from '@kizi/shared-components';

export const SwipeComponent = ({
  swiperThresholdValues = [0, 85, 149],
  children,
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [touchStartX, setTouchStartX] = useState(0);

  const handleNext = () => {
    if (activeIndex < children.length - 1) {
      setActiveIndex(activeIndex + 1);
    }
  };

  const handlePrev = () => {
    if (activeIndex > 0) {
      setActiveIndex(activeIndex - 1);
    }
  };

  const handleTouchStart = (e) => {
    setTouchStartX(e.touches[0].clientX);
  };

  const handleTouchEnd = (e) => {
    const touchEndX = e.changedTouches[0].clientX;
    const swipeDistance = touchEndX - touchStartX;

    if (swipeDistance > 50 && activeIndex > 0) {
      handlePrev();
    } else if (swipeDistance < -50 && activeIndex < children.length - 1) {
      handleNext();
    }
  };

  return (
    <Div
      css={{
        position: 'relative',
        width: '100%',
        overflow: 'hidden',
      }}
      p={3}
      pb={0}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      <Div
        css={{
          display: 'flex',
          transform: `translateX(-${swiperThresholdValues[activeIndex]}%)`,
          transition: 'transform 0.3s ease-in-out',
          gap: '24px',
        }}
      >
        {children.map((child, index) => (
          <Div
            key={index}
            css={{
              minWidth: '80%', // Card width < 100% because we need to show next card also
              boxSizing: 'border-box',
            }}
          >
            {child}
          </Div>
        ))}
      </Div>

      <Div
        css={{
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: '24px',
          alignItems: 'center',
        }}
      >
        <Icon
          name="arrow-left"
          onClick={handlePrev}
          display={['block', 'block', 'none']}
          cursor={'pointer'}
          css={{
            opacity: activeIndex > 0 ? 'unset' : 0.4,
          }}
          width={17}
          height={14}
        />

        <Div display={'flex'}>
          {children.map((_, index) => (
            <Div
              key={index}
              onClick={() => setActiveIndex(index)}
              css={{
                cursor: 'pointer',
                padding: '8px 2px',
              }}
            >
              <Div
                css={{
                  height: '4px',
                  width: '24px',
                  borderRadius: '9px',
                  backgroundColor:
                    index === activeIndex ? '#727888' : '#D9DADE',
                }}
              />
            </Div>
          ))}
        </Div>

        <Icon
          name="arrow-right"
          display={['block', 'block', 'none']}
          cursor={'pointer'}
          onClick={handleNext}
          css={{
            opacity: activeIndex < children.length - 1 ? 'unset' : 0.4,
          }}
          width={17}
          height={14}
        />
      </Div>
    </Div>
  );
};
